import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';

import '../../css/Contracts.css';
import { PagingTable,Loading,MessageBox,SelectField } from 'component-lib';
import { DateTimeHelper } from 'utils-lib';
import { RequestAjaxClass, ContractsModel, CustomerModel } from 'models-lib';

var moment = require('moment');
        moment().format();
class Contracts extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Limit = 10;
        this.state.Start = 0;
        this.state.OrderColumn = "";
        this.state.OrderDirection = "desc";
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.ContractsModel = new ContractsModel([this],null,this.Request);
        this.CustomerModel = new CustomerModel([this],null,this.Request);

        this.MultibleApproveAllowed = false;

        this.IconConfig = Vas.Config.ShowIconsOrButtons;

        this.state.all = props.match.params.all;
        this.state.ready = false;
        this.role = localStorage.getItem("vas_role");

        this.customerAboveInput = React.createRef();
    }

    componentWillMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
            ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
        })
        ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));

        this.LogoClick();

        this.FontSizeClick();
    }

    componentDidMount()
    {
        this.setState({ ready:true },()=>{
            this.setPagingStates();
        });

        $("#HeaderTitle").html(Vas.Resources.Labels["Contracts"]);

        this.LogoClick();

        this.FontSizeClick();
    }

    componentDidUpdate(){
        if (this.state.all !== this.props.match.params.all){
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ all:this.props.match.params.all },()=>{
                this.setPagingStates();
            });
        }else{
            //this.setPagingStates();
        }

        this.LogoClick();

        this.FontSizeClick();
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Contracts"){
                let items = this.ContractsModel.Contracts;
                let contracts = [];
                if (items)
                {
                    items.forEach(function(value) {
                        let contract = {};
                        contract = value;
                        contract.DateFrom = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateFrom,true,localStorage.getItem('vas_language')));
                        contract.DateTo =  value.DateTo<value.DateFrom ? "" : DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateTo,true,localStorage.getItem('vas_language')));                       
                        
                        //Hier die Bezeichnung des Status anpassen
                        //Neu an dieser Stelle Status Gekündigt (Beachte Darstellung Umpaut ü)
                        switch(value.StatusId){
                            case 2:
                                contract.Status = Vas.Resources.Labels["Canceled"];
                            break;

                            case 10:
                                contract.Status = Vas.Resources.Labels["PendingApproval"];
                            break;

                            default:
                                contract.Status = value.Status;
                            break;
                        }

                        contracts.push(contract);
                    });          
                }

                if (me.refs.table){
                    me.refs.table.setState({ Data: contracts, Start: this.ContractsModel.Start, End: this.ContractsModel.Start+contracts.length, Limit: this.ContractsModel.Limit, Count: this.ContractsModel.Count });
                }
                if(this.role === "1"){
                    ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
                }
                
            }else if(observer === "ContractsChangeBulk"){
                ReactDOM.render(<MessageBox 
                    AppURL={Vas.ApplicationUrl}
                    Message={Vas.Resources.Labels["MultibleApprove"]}
                    Title={Vas.Resources.Titles["Note"]} />, document.getElementById('messageContainer'));   
                $("#LoadingIcon").removeClass().addClass('hide');
                me.load(me.refs.table.PrepareSendData());
            }else if(observer === "CustomersAbove"){
                if(this.CustomerModel.CustomersAbove.length > 0){
                    let data= [];
                    for(let i = 0; i<this.CustomerModel.CustomersAbove.length; i++){
                        let d = {Key: this.CustomerModel.CustomersAbove[i].Id , 
                                Display : this.CustomerModel.CustomersAbove[i].Name};
                        data.push(d);
                    }

                    this.customerAboveInput.current.setState({ Data : data});
                }
                ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
            }
        })

        this.LogoClick();

        this.FontSizeClick();
    }

    getCustomerAbove(){
        this.CustomerModel.GetCustomersAboveByCustomerId(localStorage.getItem("vas_customerId"),moment().format("YYYY-MM-DD T 00:00:00"),true);
    }
    setPagingStates(){
        if (this.role === '1'){
            this.refs.table.setState({
                SearchParams:[{ Parameter: 'StatusId', SearchValue: 1 }],
                columns:[Vas.Resources.Labels["ContractNumber"],
                        Vas.Resources.Labels["Custom"] ,
                        Vas.Resources.Labels["State"], 
                        Vas.Resources.Labels["TariffProduct"],
                        Vas.Resources.Labels["Start"],
                        Vas.Resources.Labels["End"] ], 
                keys:["ContractNumber", 
                        "CustomerName", 
                        "Status",
                        "TicketName", 
                        "DateFrom",
                        "DateTo"],
                Add:false,
                AddClick:()=>{this.AddContract();},
                CWidth:[110,120,80,120,100,100],
                Filter:true,
                Action:false,
            },()=>{
                this.load(this.refs.table.PrepareSendData());
            });
        } else if (this.role === "3" || this.role === "99"){
            if (this.state.all === 'true'){
                this.refs.table.setState({
                    SearchParams:[{ Parameter: 'StatusId', SearchValue: 1 },{ Parameter: 'customerAbove', SearchValue: this.state.CustomerAbove }],
                    columns:[Vas.Resources.Labels["ContractNumber"],
                            Vas.Resources.Labels["Customer"] ,
                            Vas.Resources.Labels["Company"],
                            Vas.Resources.Labels["State"], 
                            Vas.Resources.Labels["TariffProduct"],
                            Vas.Resources.Labels["Start"],
                            Vas.Resources.Labels["End"],
                            ""
                            //Vas.Resources.Labels["School"],
                            //Vas.Resources.Labels["Street"],
                            //Vas.Resources.Labels["HouseNumber"],
                            //Vas.Resources.Labels["HouseNumberAddition"],
                            //Vas.Resources.Labels["City"],
                            //Vas.Resources.Labels["PLZ"],
                            //as.Resources.Labels["Action"]
                        ],
                    keys:["ContractNumber", 
                            "CustomerName", 
                            "CustomerAbove",
                            "Status",
                            "TicketName", 
                            "DateFrom",
                            "DateTo",
                            //"CustomerAbove",
                            //"Street",
                            //"HouseNumber",
                            //"HouseNumberAddition",
                            //"City",
                            //"Zip"
                        ],
                    Filter:true,
                    Action:false,
                    Delete:true,
                    Add:true,
                    //CWidth:[100,120,70,120,100,100,150,150,70,70,100,70,45]
                    CWidth:[92,195,195,130,130,95,95]
                },()=>{
                    //this.load(this.refs.table.PrepareSendData());
                    this.getCustomerAbove();
                });
            } else {
                this.refs.table.setState({
                    SearchParams:[{ Parameter: "StatusId", SearchValue: 10 }],
                    columns:[Vas.Resources.Labels["ContractNumber"],
                    Vas.Resources.Labels["Customer"] ,
                    Vas.Resources.Labels["State"], 
                    Vas.Resources.Labels["TariffProduct"],
                    Vas.Resources.Labels["Start"],
                    Vas.Resources.Labels["End"],
                    ""
                    //Vas.Resources.Labels["School"],
                    //Vas.Resources.Labels["Street"],
                    //Vas.Resources.Labels["HouseNumber"],
                    //Vas.Resources.Labels["HouseNumberAddition"],
                    //Vas.Resources.Labels["City"],
                    //Vas.Resources.Labels["PLZ"]
                    ], 
                    keys:["ContractNumber", 
                        "CustomerName", 
                        "Status",
                        "TicketName", 
                        "DateFrom",
                        "DateTo",
                        //"CustomerAbove",
                        //"Street",
                        //"HouseNumber",
                        //"HouseNumberAddition",
                        //"City",
                        //"Zip"
                    ],
                    Action:false,
                    Filter:false,
                    Delete:false,
                    Add:false,
                    //CWidth:[100,120,70,120,100,100,150,150,70,70,100,70]
                    CWidth:[92,230,130,130,95,95]
                },()=>{
                    //this.load(this.refs.table.PrepareSendData());
                    this.getCustomerAbove();
                });
            }
        }
    }

    load(sendData, trigger = 'blubb')
    {
        if (this.state.ready === true){
            if (this.role !== '1'){

                if(this.state.CustomerAbove){
                    let searchParams = this.refs.table.state.SearchParams;
                    let idx = -1;
                    for(let i = 0; i<searchParams.length; i++){
                        if(searchParams[i].Parameter === "customerAboveId"){
                            idx = i;
                        }
                    }
                    if(idx >=0){
                        searchParams.splice(idx,1);
                    }
                    
                    searchParams.push({ Parameter: 'customerAboveId', SearchValue: this.state.CustomerAbove });
                    
                    this.refs.table.setState({
                        SearchParams:searchParams},()=>{
                            sendData = this.refs.table.PrepareSendData();

                            let sendDataArray = sendData.split('&');
                            let sendDataCorrectedString = "";

                            if(trigger == "Firma"){
                                //Hier Start auf den Initialwert zurückstellen
                                //Problem: Firma 1 gewählt -> 500 Mitarbeiter, Pager auf letzter Seite (start = 450, limit = 50), wenn danach Firma 2 gewählt -> 100 Mitarbeiter,
                                //wird nichts gefunden, da start bei 450, darum in diesem Fall start wieder auf 0 stellen.
                                sendDataCorrectedString = sendDataArray[0] + "&start=0&";      //sendData beginnt immer mit ?limit= und start=
                            }else {
                                sendDataCorrectedString = sendDataArray[0] + "&" + sendDataArray[1] + "&";      //sendData beginnt immer mit ?limit= und start=
                            }

                            if($('#Filter').val() == undefined){
                                sendDataCorrectedString += "StatusId=10&";              //als nächstes der Status, wird auch immer benötigt
                            } else if($('#Filter').val() != "-1"){
                                sendDataCorrectedString += "StatusId=" + $('#Filter').val() + "&";              //als nächstes der Status, wird auch immer benötigt
                            }

                            sendDataCorrectedString += "customerAboveId=" + $('#CustomerAbove').val() + "&";    //als nächstes die Firma, wird auch immer benötigt

                            //Werden die Spalten sortiert?
                            if(sendData.indexOf("orderColumn") > -1){
                                if(sendDataArray[2].indexOf("ContractNumber") > -1){
                                    sendDataCorrectedString += "orderColumn=Vertragsnr&" + sendDataArray[3] + "&";
                                } else if(sendDataArray[2].indexOf("DateFrom") > -1){
                                    sendDataCorrectedString += "orderColumn=DatumVon&" + sendDataArray[3] + "&";
                                } else if(sendDataArray[2].indexOf("DateTo") > -1){
                                    sendDataCorrectedString += "orderColumn=DatumBis&" + sendDataArray[3] + "&";
                                } else if(sendDataArray[2].indexOf("TicketName") > -1){
                                    sendDataCorrectedString += "orderColumn=KurzbezBeanstan&" + sendDataArray[3] + "&";
                                }
                            }

                            if($('#search').val() != "" && $('#search').val() != undefined){

                                switch($('#SearchParams').val()){
                                    case "DateFrom":
                                        let selectedDateFrom = $('#search').val().split('.'); //01.06.2023 -> 01 06 2023
                                        //Problem 01.06.2023 wird bei Übergabe an die API zu 06.01.2023, darum hier 06.01.2023 übergeben, was dann in der API zu 01.06.2023
                                        sendDataCorrectedString += "DateFrom=" + selectedDateFrom[1] + "." + selectedDateFrom[0] + "." + selectedDateFrom[2] + "&";
                                        break;
                                    case "DateTo":
                                        let selectedDateTo = $('#search').val().split('.'); //01.06.2023 -> 01 06 2023
                                        //Problem 01.06.2023 wird bei Übergabe an die API zu 06.01.2023, darum hier 06.01.2023 übergeben, was dann in der API zu 01.06.2023
                                        sendDataCorrectedString += "DateTo=" + selectedDateTo[1] + "." + selectedDateTo[0] + "." + selectedDateTo[2] + "&";
                                        break;
                                    case "ContractNumber":
                                        sendDataCorrectedString += "ContractNumber=" + $('#search').val() + "&";
                                        break;
                                    case "TicketName":
                                        sendDataCorrectedString += "beanstanshortcut=" + $('#search').val() + "&";
                                        break;
                                    case "CustomerName":
                                        sendDataCorrectedString += "CustomerName=" + $('#search').val() + "&";
                                        break;
                                }
                            }

                            if(trigger == "Firma"){
                                //Prüfung, ob die Firma gefüllt ist (FirmenGuid) 
                                //Bei der Wahl von Bitte wählen ist die FirmenGuidd leer, also darf hier nicht gesucht werden, 
                                //da es bei der Suche sonst zu einem Fehler (API Konvertierung FirmenGuid(leer) zur CustomerId(Id_B2Kunde))
                                if($('#CustomerAbove').val() != "" && $('#CustomerAbove').val() != undefined){
                                    //Korrektur letztes &
                                    sendData = sendDataCorrectedString.substr(0, sendDataCorrectedString.length - 1);

                                    this.ContractsModel.GetContracts(sendData);
                                }
                            } else {
                                //Korrektur letztes &
                                sendData = sendDataCorrectedString.substr(0, sendDataCorrectedString.length - 1);

                                this.ContractsModel.GetContracts(sendData);
                            }
                        });
                }
                
            }else{
                this.ContractsModel.GetContracts(sendData);
            }
            
        }
    }

    loadContract(id){
        let me = this;
        let customerId = "";
        let customerName = "";

        for (let i = 0; i < me.refs.table.state.Data.length; i++)
        {
            if (me.refs.table.state.Data[i].Id === id)
            {
                customerId = me.refs.table.state.Data[i].IdCustomer;
                customerName = me.refs.table.state.Data[i].CustomerName;
                break;
            }
        }
       
        Vas.GetView("Contract", { Id: id, CustomerId: customerId, CustomerName: customerName }, true);
    }

    Cancel(event){
        let me = this;
        let id = $(event.target).parent().parent().parent().parent().parent().parent().parent("tr")[0].id;
        for (let i = 0; i < me.refs.table.state.Data.length; i++)
        {
            if (me.refs.table.state.Data[i].Id === id)
            {
                localStorage.setItem('contract',JSON.stringify(me.refs.table.state.Data[i]));
                break;
            }
        }
        Vas.GetView("ContractCancel",null,true);
    }

    MultibleApprove(ids){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        
        this.ContractsModel.ContractsChangeStatusBulk(ids,"",true,false);
    }

    CreateContract(){
        Vas.GetView("Order", { CustomerId: '00000', ContractId : '00000' }, true);
    }

    LogoClick(){

        var kontrastNumber = localStorage.getItem('Kontrast');
        let role = localStorage.getItem("vas_role");

        $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenue div div div#MenuItems.Menu-items').attr('style', 'top: -80px !important;')
    
        if(kontrastNumber == "true"){
            $(".loader").attr('style', 'border-top: 16px solid #1d5c87; border-bottom: 16px solid #1d5c87; z-index: 1;');


            $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87;');
            $('.pagingTable th, .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');

            if (role === '3'){
                $('.contractForm th[id="0"]').attr('style', 'width: 92px !important; cursor: pointer;');
                $('.contractForm th[id="1"]').attr('style', 'width: 195px !important;');
                $('.contractForm th[id="2"]').attr('style', 'width: 195px !important;');
                $('.contractForm th[id="3"]').attr('style', 'width: 130px !important;');
                $('.contractForm th[id="4"]').attr('style', 'width: 130px !important;');
                $('.contractForm th[id="5"]').attr('style', 'width: 95px !important; cursor: pointer;');
                $('.contractForm th[id="6"]').attr('style', 'width: 95px !important; cursor: pointer;');

                $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');

                

                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#0.tableHeaderHeader').attr('style', 'width: 92px !important; cursor: pointer; border-bottom: 1px solid #1d5c87; padding-right: 130px !important;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').attr('style', 'width: 195px !important; border-bottom: 1px solid #1d5c87;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader').attr('style', 'width: 195px !important; border-bottom: 1px solid #1d5c87;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader').attr('style', 'width: 130px !important; border-bottom: 1px solid #1d5c87;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader').attr('style', 'width: 130px !important; border-bottom: 1px solid #1d5c87;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').attr('style', 'cursor: pointer; width: 95px !important; border-bottom: 1px solid #1d5c87;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader').attr('style', 'cursor: pointer; width: 95px !important; border-bottom: 1px solid #1d5c87;');
            }   
            


            $('#MenuItem_Download_CSV').attr('style', 'background-color: #1d5c87;');
            $('#MenuItem_Add').attr('style', 'background-color: #1d5c87;');

            $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');
            $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
            $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
            $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
                $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
            });

            $(".selected").mouseenter(function() {
                $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
            });

            $(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #1d5c87;');

            $('.contractForm').attr('style', 'border: 1px solid #1d5c87;');

            $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('.extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

          $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
        }else{
            if(role === '3'){
                $('.contractForm th[id="0"]').attr('style', 'width: 92px !important; cursor: pointer;');
                $('.contractForm th[id="1"]').attr('style', 'width: 195px !important;');
                $('.contractForm th[id="2"]').attr('style', 'width: 195px !important;');
                $('.contractForm th[id="3"]').attr('style', 'width: 130px !important;');
                $('.contractForm th[id="4"]').attr('style', 'width: 130px !important;');
                $('.contractForm th[id="5"]').attr('style', 'width: 95px !important; cursor: pointer;');
                $('.contractForm th[id="6"]').attr('style', 'width: 95px !important; cursor: pointer;');

                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#0.tableHeaderHeader').attr('style', 'width: 92px !important; cursor: pointer; border-bottom: 1px solid #3393d3; padding-right: 130px !important;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').attr('style', 'width: 195px !important; border-bottom: 1px solid #3393d3;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader').attr('style', 'width: 195px !important; border-bottom: 1px solid #3393d3;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader').attr('style', 'width: 130px !important; border-bottom: 1px solid #3393d3;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#4.tableHeaderHeader').attr('style', 'width: 130px !important; border-bottom: 1px solid #3393d3;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').attr('style', 'cursor: pointer; width: 95px !important; border-bottom: 1px solid #3393d3;');
                $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#6.tableHeaderHeader').attr('style', 'cursor: pointer; width: 95px !important; border-bottom: 1px solid #3393d3;');
            }
        }
    }

    FontSizeClick(){
        var schriftgröße = localStorage.getItem('Schriftgröße');
        let role = localStorage.getItem("vas_role");
  
        //Schriftgröße bei Klick in 2er Schritten erhöhen
  
          if(schriftgröße != null){
              
                switch(schriftgröße){
                  case "0":

                        if (role === '3'){
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').addClass('paddingLeft0');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').addClass('paddingLeft0');

                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Hinzufügen').removeClass('Schriftgröße_18').addClass('Schriftgröße_19');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_18 downloadCsvPadding_1102').addClass('Schriftgröße_19 downloadCsvPadding_1102');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Add').removeClass('Schriftgröße_18 downloadCsvPadding_1102').addClass('Schriftgröße_19 downloadCsvPadding_1102');
                        }
                  break;
                  case "1":
  
                        if (role === '3'){
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').addClass('paddingLeft0');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').addClass('paddingLeft0');

                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Hinzufügen').removeClass('Schriftgröße_19').addClass('Schriftgröße_14');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_19 downloadCsvPadding1102').addClass('Schriftgröße_14');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Add').removeClass('Schriftgröße_19 downloadCsvPadding1102').addClass('Schriftgröße_14');
                        }
  
                  break;
                  case "2":

                        if (role === '3'){
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').addClass('paddingLeft0');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').addClass('paddingLeft0');

                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Hinzufügen').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_14').addClass('Schriftgröße_15 downloadCsvPadding1106');
                            $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Add').removeClass('Schriftgröße_14').addClass('Schriftgröße_15 downloadCsvPadding1106');
                        }
  
                  break;
                  case "3":
                        if (role === '3'){
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').removeClass('paddingLeft0').addClass('paddingLeft20');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').addClass('paddingLeft0');

                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Hinzufügen').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_15 downloadCsvPadding1106').addClass('Schriftgröße_16 downloadCsvPadding1106');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Add').removeClass('Schriftgröße_15 downloadCsvPadding1106').addClass('Schriftgröße_16 downloadCsvPadding1106');
                        }
                  break;
                  case "4":

                        if (role === '3'){
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').addClass('paddingLeft20');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').removeClass('paddingLeft0').addClass('paddingLeft20');

                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Hinzufügen').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_16 downloadCsvPadding1106').addClass('Schriftgröße_17 downloadCsvPadding1104');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Add').removeClass('Schriftgröße_16 downloadCsvPadding1106').addClass('Schriftgröße_17 downloadCsvPadding1104');
                        }
                  break;
                  case "5":                
  
                        if (role === '3'){
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader').addClass('paddingLeft20');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#5.tableHeaderHeader').addClass('paddingLeft20');

                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Hinzufügen').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Download_CSV').removeClass('Schriftgröße_17 downloadCsvPadding1104').addClass('Schriftgröße_18 downloadCsvPadding1102');
                          $('div div div.form.contractForm div#contractsFkv table#table.pt tbody tr td table.headerTableWithoutBorder tbody tr td#burger.BurgerMenueLong div div div#MenuItems.Menu-items div#MenuItem_Add').removeClass('Schriftgröße_17 downloadCsvPadding1104').addClass('Schriftgröße_18 downloadCsvPadding1102');
                        }
                  break;
                }
          }
    }

    render()
    {
        let role = localStorage.getItem("vas_role");
        let label ='';
        let del = false;
        let action = false;
        let add = false;
        if (role === '3'){
            label = Vas.Resources.Labels["Employee"];
            del = true;
            if(this.MultibleApproveAllowed === true){
               action = true; 
            }
            if(this.state.all === true){
               add = true; 
            }
            
        }else{
            label = Vas.Resources.Labels["Customer"];
        }

        let company = <div></div>;
        let columns =[];
        let pagingTable = <div></div>;
        let table = <div></div>;

        if(this.role === "1"){
            pagingTable = (<PagingTable
                ref="table"
                TableReference={this}
                DataBaseTable={"B2Vertraege"}
                SearchParams={[{ Parameter: 'StatusId', SearchValue: 1 }]}
                SearchCol={"ContractNumber"}
                Selectable={false}
                Start={this.state.Start}
                End={this.state.End}
                Limit={10}
                Count={this.state.Count} 
                Data={this.state.Data}
                Add={add}
                AddClick={()=>{this.CreateContract();}}
                Download={false} 
                Search={false}
                CSV={true}
                CSVTableName={Vas.Resources.Labels["Contracts"]} 
                CSVController={"/Contracts"}
                Keys={["ContractNumber"]} 
                Columns={[Vas.Resources.Labels["ContractNumber"]]}
                AppURL={Vas.ApplicationUrl}
                ApiURL={Vas.ApiUrl}
                ApiKey={Vas.ApiKey}
                SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                TooltipCsvDownload={Vas.Resources.Tooltips["CsvDownload"]}
                LabelPage={Vas.Resources.Labels["Page"]}
                LabelOf={Vas.Resources.Labels["Of"]}
                LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                Filter={true}
                FilterData={[{ Key:"-1", Display:Vas.Resources.Labels["AllContracts"] },{ Key:"1", Display:Vas.Resources.Labels["Active"] },{ Key:"2", Display:Vas.Resources.Labels["Canceled"] },{ Key:"10", Display:Vas.Resources.Labels["PendingApproval"] }]} 
                FilterColoumn={"StatusId"}
                FilterText={Vas.Resources.Labels["Filter"]}
                FilterDefault={Vas.Resources.Labels["Active"]}
                //CWidth={[120,200,200,100,180,100, 100]}
                Width={700}
                AddString={Vas.Resources.Labels["Add"]}
                RowOnClick={(id)=>{this.loadContract(id);}}
                Delete={del}
                DeleteOnClick={(event)=>{this.Cancel(event);}}
                DeleteValue={1}
                DeleteId={"StatusId"}
                LabelConfirm={Vas.Resources.Labels["Confirm"]}
                LabelCancel={Vas.Resources.Labels["Cancel"]}
                Action={action}
                Actions={[{ String:Vas.Resources.Labels["Approve"], OnClick:(ids)=>{this.MultibleApprove(ids);} }]} 
                ActionLabel={[Vas.Resources.Labels["ActionConfirm"],Vas.Resources.Labels["ActionConfirm2"],Vas.Resources.Labels["ActionConfirm3"]]}
                ShowIcons={this.IconConfig.ShowIcons}  />);

            table = (<div id={"contracts"}> 
            {company}
            {pagingTable}
          </div>);

        } else if(this.role === "3"){
            company = (
                <SelectField
                AppURL={this.ApplicationUrl} 
                me={this} 
                ref={this.customerAboveInput} 
                Id={"CustomerAbove"} 
                IsRequired={true} 
                Label={Vas.Resources.Labels["Company"]} 
                Tooltip={Vas.Resources.Tooltips["Company"]}
                OnChange={()=>{ this.setState({ CustomerAbove: $("#CustomerAbove").val() },()=>{this.load(this.refs.table.PrepareSendData(), "Firma");});}} />

            );

            columns = [Vas.Resources.Labels["ContractNumber"], Vas.Resources.Labels["Start"], Vas.Resources.Labels["End"]];

            pagingTable = (<PagingTable
                    ref="table"
                    TableReference={this}
                    DataBaseTable={"B2Vertraege"}
                    SearchParams={[{ Parameter: 'StatusId', SearchValue: 1 }]}
                    SearchCol={["ContractNumber", "Employee", "Tarifprodukt", "Start", "End"]}
                    Selectable={false}
                    Start={this.state.Start}
                    End={this.state.End}
                    Limit={10}
                    Count={this.state.Count} 
                    Data={this.state.Data}
                    Add={add}
                    AddClick={()=>{this.CreateContract();}}
                    Download={false} 
                    Search={true}
                    CSV={true}
                    CSVTableName={Vas.Resources.Labels["Contracts"]} 
                    CSVController={"/Contracts"}
                    Keys={["ContractNumber", "CustomerName", "TicketName", "DateFrom", "DateTo"]} 
                    Columns={[Vas.Resources.Labels["ContractNumber"], Vas.Resources.Labels["Employee"], Vas.Resources.Labels["TariffProduct"], Vas.Resources.Labels["Start"], Vas.Resources.Labels["End"]]}
                    SortColumns={columns}
                    AppURL={Vas.ApplicationUrl}
                    ApiURL={Vas.ApiUrl}
                    ApiKey={Vas.ApiKey}
                    SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                    TooltipCsvDownload={Vas.Resources.Tooltips["CsvDownload"]}
                    LabelPage={Vas.Resources.Labels["Page"]}
                    LabelOf={Vas.Resources.Labels["Of"]}
                    LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                    Filter={true}
                    FilterData={[{ Key:"-1", Display:Vas.Resources.Labels["AllContracts"] },{ Key:"1", Display:Vas.Resources.Labels["Active"] },{ Key:"2", Display:Vas.Resources.Labels["Canceled"] },{ Key:"10", Display:Vas.Resources.Labels["PendingApproval"] }]} 
                    FilterColoumn={"StatusId"}
                    FilterText={Vas.Resources.Labels["Filter"]}
                    FilterDefault={Vas.Resources.Labels["Active"]}
                    //CWidth={[120,200,200,100,180,100, 100]}
                    Width={700}
                    AddString={Vas.Resources.Labels["Add"]}
                    RowOnClick={(id)=>{this.loadContract(id);}}
                    Delete={del}
                    DeleteOnClick={(event)=>{this.Cancel(event);}}
                    DeleteValue={1}
                    DeleteId={"StatusId"}
                    LabelConfirm={Vas.Resources.Labels["Confirm"]}
                    LabelCancel={Vas.Resources.Labels["Cancel"]}
                    Action={action}
                    Actions={[{ String:Vas.Resources.Labels["Approve"], OnClick:(ids)=>{this.MultibleApprove(ids);} }]} 
                    ActionLabel={[Vas.Resources.Labels["ActionConfirm"],Vas.Resources.Labels["ActionConfirm2"],Vas.Resources.Labels["ActionConfirm3"]]}
                    ShowIcons={this.IconConfig.ShowIcons}  />);

            table = (<div id={"contractsFkv"}> 
                {company}
                {pagingTable}
            </div>);
        }

        return (
          <div className={"form contractForm"}>
              {table}
          </div> 
        );
    }
}
export default Contracts;
